var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"photo"},[_c('van-uploader',{attrs:{"multiple":"","after-read":_vm.afterRead,"max-count":1,"preview-size":"160px"},model:{value:(_vm.fileList),callback:function ($$v) {_vm.fileList=$$v},expression:"fileList"}}),_c('div',{staticClass:"update",on:{"click":_vm.back}},[_vm._v("Back")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }